export default class ShowHideModule {
	constructor() {

		this.buttons = document.querySelectorAll('[data-vacancy-btn]');

        if(!this.buttons) {
            return;
        }

		this.elements = document.querySelectorAll('[data-content-wrapper]');

		this.buttons.forEach((el) => {

			el.addEventListener('click', (e) =>  {

				const tabName =  e.currentTarget.dataset.vacancyBtn;

				this.activateTab(tabName);
			});
		});
    }

	activateTab(name) {

		this.elements.forEach((content) => {
			content.classList.remove('is-visible');
		});

		const targetName = document.querySelector(`[data-content-wrapper="${name}"]`);

		targetName.classList.add('is-visible');

		if(name === "application") {
			document.getElementById('input_4_1').focus();
		}

		this.buttons.forEach((button) => {
			button.classList.remove('is-active');

			if(button.dataset.vacancyBtn === name) {
				button.classList.add('is-active');
			}
		});
	}
}
